module.exports = __webpack_public_path__ + "static/media/paletteGenerator1.e284c6eb.jpg";